export default __webpack_public_path__ + "static/media/oscer-fever-travel.c12255d0.svg";